import { Component } from 'react';
import * as React from 'react';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { Loading } from '../../uiComponents/Loading';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { KonkurrenceTable } from '../konkurrence/KonkurrenceTable';
import { Section } from '../../uiComponents/layout/Section';
import { LinkPrimaryButton, LinkSecondaryButton, LinkSectionButton } from '../../uiComponents/input/Buttons';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Konkurrence } from '../../models/Konkurrence';

export interface SkrivebordAdministratorProps {
}

interface SkrivebordAdministratorState {
    konkurrencer?: Konkurrence[];
}

class SkrivebordAdministrator extends Component<SkrivebordAdministratorProps, SkrivebordAdministratorState> {
    constructor(props: SkrivebordAdministratorProps) {
        super(props);

        this.state = {konkurrencer: undefined};
    }

    componentDidMount() {
        var self = this;
        
        var result = createApiCaller().getKommendeKonkurrencer();
        result.then(function (json: any) {
            self.setState({ konkurrencer: json });
        });
    }

    render() {
        let headerButtons = <LinkPrimaryButton url={'/konkurrence/ny'} text={'Ny konkurrence'} />;
        return (
            <PageWrapper>
                <PageTitle title='Administration' />
                <Loading isLoading={this.state.konkurrencer === undefined}>
                    <ContentWrapper>
                        <SectionGroup header={'Kommende konkurrencer'} buttons={headerButtons}>
                            <Section fullWidth={true}>
                                <KonkurrenceTable konkurrencer={this.state.konkurrencer} />
                            </Section>
                            <ButtonSection>
                                <LinkSecondaryButton className='spacer' url='/konkurrencer' text='Se alle konkurrencer' />
                            </ButtonSection>
                        </SectionGroup>

                        <SectionGroup header={'Konkurrencemateriale'} >
                            <LinkSectionButton url='/opgaver' text='Opgaver' />
                            <LinkSectionButton url='/opgavepakker' text='Opgavepakker' />
                            <LinkSectionButton url='/logboeger' text='Logbøger' />                            
                        </SectionGroup>
                    </ContentWrapper>
                </Loading>
            </PageWrapper>
        );
    }
}

export default SkrivebordAdministrator;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/SkrivebordAdministrator.tsx